module.exports = __webpack_public_path__ + "img/texture.5ddc680e.jpg";